import { TILE_CHANGE } from './types';

export const changeTile = (tile) => (dispatch) => {
	dispatch({
		type: TILE_CHANGE,
		payload: tile,
	});
};
